<template>
    <div>
        <v-file-input
                :rules="rules"
                v-model="file"
                :label="label"
                show-size
                truncate-length="25"
                clearable
                prepend-icon="mdi-microsoft-excel"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet/vnd.ms-excel"
                ref="v-file"
        ></v-file-input>
    </div>
</template>

<script>
    export default {
        name: "ImportExcel",
        props: {
            label: {
                type: String,
                default: 'File input'
            }
        },
        data: () => ({
            file: null,
            rules: [
                value => !value || value.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||  value.type === 'application/vnd.ms-excel' || '엑셀 파일이 아닙니다. ',
            ],
        }),
        watch : {
            file(v){
                if(v === undefined){
                    this.$emit('fileIsReady', false);
                } else {
                    this.$emit('fileIsReady', true);
                }
            }
        },
    }
</script>

<style scoped>

</style>